import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { localStorageAvailable } from '../_helpers/local-storage-available';
import { localStorageAuthUser } from '../_common/constants';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private readonly router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (localStorageAvailable()) {
            if (localStorage.getItem(localStorageAuthUser)) {
                return true;
            }
            this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/_guards/auth.guard.ts